import React from 'react';

const DownloadIcon = () => (
  <svg width="18" height="16" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 4.33398V8.33398M7 8.33398L5.66667 7.00065M7 8.33398L8.33333 7.00065M4.6 10.6673C2.61177 10.6673 1 9.07026 1 7.10018C1 5.46737 2.2 3.95898 4 3.66732C4.56463 2.3249 5.90093 1.33398 7.45951 1.33398C9.45603 1.33398 11.0878 2.88232 11.2 4.83398C12.2595 5.29724 13 6.43419 13 7.66523C13 9.32324 11.6569 10.6673 10 10.6673L4.6 10.6673Z" stroke="#5941A9" strokeWidth="0.96" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default DownloadIcon;
